import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

// Shared with preloadInitialRoute, so a cold load fetches the page chunk in parallel with the boot gates.
export const importHomePage = () => import('@cobliteam/home');

const HomePage = lazy(importHomePage);

const routes = [
  {
    path: Location.HOME,
    team: 'squad-gf-core',
    component: HomePage,
  },
];

export default routes;
